import {
  MessageBar,
  MessageBarBody,
  SkeletonItem,
  tokens
} from "@fluentui/react-components";
import * as React from "react";
import { FormattedMessage } from "react-intl";
import { ValidationStatus } from "../abstractions/EAppValidation";
import { IAppValidationItem } from "../abstractions/IAppValidation";


export const ValidationWarning: React.FC<{ currentValidation: IAppValidationItem | null }> = ({ currentValidation }) => {
  if (!currentValidation) {
    return <SkeletonItem style={{ width: "100%" }} />
  }
  if (currentValidation.status === ValidationStatus.Completed) {
    return (
      <MessageBar intent="warning">
        <MessageBarBody style={{ color: tokens.colorNeutralForeground1 }}>
          <FormattedMessage
            description="validation warning message"
            defaultMessage="Validation results will be deleted after 30 days. You can download these results to reference them later." />
        </MessageBarBody>
      </MessageBar>
    )
  }
  return <></>
}